
// ENV_CONST
// - is imported by the following require function. (client side)
// - is imported globally by "import" tag on jal_intl.xml. (server side)
if (typeof require === "function") {
	var ENV_CONST = require("./env-const.js");
}

function generateURL(contextPath) {
	function getExternalLink(detail) {
		const hotelGradeBase = "https://" + ENV_CONST.jmbtourUrl + "/sp/history/inttour/hotelgrade/createhtml";
		
		const qstirng = [
				"year=" + detail.year.replace(/^\s+|\s+$/g,''),
				"period=" + detail.half.replace(/^\s+|\s+$/g,''),
				"company=" + detail.company.replace(/^\s+|\s+$/g,''),
				"brand=" + detail.brand_code.replace(/^\s+|\s+$/g,''),
				"area=" + detail.destination_code.replace(/^\s+|\s+$/g,''),
				"code=" + detail.course_number.replace(/\s+/, ""),
				"forciaflg=1"
			].join("&amp;");
		return {
			hotelGradeList: hotelGradeBase + "?" + qstirng
		};
	}

	function addon(obj) {
		// 国内線追加プラン
		const year = obj.year;
		const half = obj.half;
		const destCode = obj.destination_code;
		const replacedDestCode = destCode.replace(/^\s+|\s+$/g,'').replace("TWN","ASI");
		return "//"+ ENV_CONST.jmbtourUrl + "/system/tour/Addon/" +
				year + "_" + half + "/" + replacedDestCode + "_SP.html";
	}
	const intlTop = "//intltoursearch.jal.co.jp";
	const url = {
		contextPath: contextPath,
		img: [contextPath, "common", "img"].join("/"),
		mobile: {
			// internal link
			searchFull: intlTop + [contextPath,  "sp/"].join("/"),
			search: [contextPath,  "sp/"].join("/"),
			detail: [contextPath,  "sp", "detail"].join("/"),
			landing: [contextPath, "sp", "landing/"].join("/"),
			css: [contextPath, "common", "mobile", "css"].join("/"),
			img: [contextPath, "common", "mobile", "img"].join("/"),
			searchjs: [contextPath, "mobile", "dist", "search.bundle.js"].join("/"),
			detailjs: [contextPath, "mobile", "dist", "detail.bundle.js"].join("/"),
			landingjs: [contextPath, "mobile", "dist", "landing.bundle.js"].join("/"),
			loa:"/loa/stream/jal_intl/mobile.js",
			// external link
			top: "//www.jal.co.jp/jp/ja/intltour/promotion/",
			dp: "//www.jal.co.jp/jp/ja/intltour/omakase-portal/",
			maintenance: "//sp5971.jal.co.jp/sp/NifSysMainte.do",
			tourImage: function(detail) {
				return intlTop + "/jal_intl/images/photo" + detail.image_file;
			},
			tourImages: function(detail) { // for detail
				var ary_image_files = detail.ary_image_files.split("\t");
				return _.map(ary_image_files, function(image_file){
					return intlTop + "/jal_intl/images/photo" + image_file;
				});
			},
			tourImageDummy: contextPath + "/common/img/pic_dummy.jpg",
			hotelGradeList: function(detail) {
				return getExternalLink(detail).hotelGradeList;
			},
			importantNotice: function(path) {
				return "https://contents.jal.co.jp" + path;
			},
			material: "//jmbtour.jal.co.jp/pc/history/inttour/material/init",
			airportTax: "//" + ENV_CONST.jmbtourUrl +"/common/AirPortTax_SP.html",
			kids: "//sp.jal.co.jp/tours/guide/readme/kids.html",
			mile: "//sp.jal.co.jp/tours/guide/readme/mile.html",
			landonly: "//sp.jal.co.jp/intltour/landonly/",
			addon:  addon,
			trancontrol: "https://" + ENV_CONST.jmbtourUrl + "/pc/common/trancontrol/init1",
			dispatcher: ENV_CONST.dispatcherUrl
		},
		pc: {
			// internal link
			searchFull: intlTop + contextPath + "/",
			detail: [contextPath,  "detail"].join("/"),
			landing: [contextPath, "landing"].join("/")
		},
		domain: ENV_CONST.canonicalUrl
	};
	return url;
}

if (typeof module !== "undefined" && module.exports) {
	module.exports = generateURL;
}



// WEBPACK FOOTER //
// ./web/WEB-INF/script/url.js